import { Serializable } from '@admin/core/models/serializable';

export class GenericResult implements Serializable<GenericResult> {
  fromObject(obj: any): GenericResult {
    Object.assign(this, obj);
    return this;
  }

  toObject() {
    throw new Error('Method not implemented.');
  }

  public success: boolean;
  public error: string;
  public errorCode: number;
}
